import React from 'react';
import styled, { keyframes } from 'styled-components';

const opaque = keyframes`
    0% {
      opacity: 0.1;
    }
    
    40% {
      opacity: 1;
    }
    
    80% {
      opacity: 0.1;
    }
    
    100% {
      opacity: 0.1;
    }
`;

const StyledComponent = styled.div`
  --loader-dot-biggest-spacing: calc(1.5 * var(--loader-dot-size, 10px));
  --loader-dot-lowest-spacing: calc(0.6666 * var(--loader-dot-biggest-spacing));
  position: relative;
  width: auto;
  height: auto;
  .dot {
    height: var(--loader-dot-size, 10px);
    width: var(--loader-dot-size, 10px);
    background-color: currentColor;
    border-radius: 50%;
    position: absolute;
    transform: translate3d(-50%, -50%, 0);
    animation: var(--loader-animation-time, 0.8s) ${opaque} ease-in-out infinite
      both;
    &:nth-child(1) {
      top: calc(
        -1 * (0.5 * var(--loader-dot-size, 10px) +
              var(--loader-dot-biggest-spacing))
      );
      left: 0;
    }
    &:nth-child(2) {
      top: calc(
        -1 * (0.5 * var(--loader-dot-size, 10px) +
              var(--loader-dot-lowest-spacing))
      );
      left: calc(
        0.5 * var(--loader-dot-size, 10px) + var(--loader-dot-lowest-spacing)
      );
      animation-delay: 0.1s;
    }
    &:nth-child(3) {
      top: 0;
      left: calc(
        0.5 * var(--loader-dot-size, 10px) + var(--loader-dot-biggest-spacing)
      );
      animation-delay: 0.2s;
    }
    &:nth-child(4) {
      top: calc(
        0.5 * var(--loader-dot-size, 10px) + var(--loader-dot-lowest-spacing)
      );
      left: calc(
        0.5 * var(--loader-dot-size, 10px) + var(--loader-dot-lowest-spacing)
      );
      animation-delay: 0.3s;
    }
    &:nth-child(5) {
      top: calc(
        0.5 * var(--loader-dot-size, 10px) + var(--loader-dot-biggest-spacing)
      );
      left: 0;
      animation-delay: 0.4s;
    }
    &:nth-child(6) {
      top: calc(
        0.5 * var(--loader-dot-size, 10px) + var(--loader-dot-lowest-spacing)
      );
      left: calc(
        -1 * (0.5 * var(--loader-dot-size, 10px) +
              var(--loader-dot-lowest-spacing))
      );
      animation-delay: 0.5s;
    }
    &:nth-child(7) {
      top: 0;
      left: calc(
        -1 * (0.5 * var(--loader-dot-size, 10px) +
              var(--loader-dot-biggest-spacing))
      );
      animation-delay: 0.6s;
    }
    &:nth-child(8) {
      top: calc(
        -1 * (0.5 * var(--loader-dot-size, 10px) +
              var(--loader-dot-lowest-spacing))
      );
      left: calc(
        -1 * (0.5 * var(--loader-dot-size, 10px) +
              var(--loader-dot-lowest-spacing))
      );
      animation-delay: 0.7s;
    }
  }
`;

const CircleDotsLoader = () => (
  <StyledComponent className="circle-loader">
    <div className="dot"></div>
    <div className="dot"></div>
    <div className="dot"></div>
    <div className="dot"></div>
    <div className="dot"></div>
    <div className="dot"></div>
    <div className="dot"></div>
    <div className="dot"></div>
  </StyledComponent>
);

export default CircleDotsLoader;
